<template>
  <div :class="{ translateY }">
    <slot />
  </div>
</template>

<script>
import { reactive, onMounted, onUnmounted, toRefs } from '@vue/composition-api'

export default {
  props: {
    offset: {
      type: Number,
      default: 50,
    },
  },
  setup({ offset }) {
    const state = reactive({
      scrollProg: undefined,
      currentPos: undefined,
      previousPos: undefined,
      translateY: undefined,
    })

    const handleScrolling = () => {
      state.currentPos = window.pageYOffset || document.documentElement.scrollTop

      if (state.currentPos < 0) {
        return
      }

      if (Math.abs(state.currentPos - state.previousPos) < offset) {
        return
      }

      state.translateY = state.currentPos > state.previousPos
      state.previousPos = state.currentPos
    }

    onMounted(() => {
      state.previousPos = window.pageYOffset

      window.addEventListener('scroll', handleScrolling)
    })

    onUnmounted(() => window.removeEventListener('scroll', handleScrolling))

    return {
      ...toRefs(state),
    }
  },
}
</script>

<style lang="scss" scoped>
// nav {
//   position: fixed;
//   right: 0;
//   left: 0;
//   height: 100px;
//   background-color: #000;
//   transition: {
//     duration: 300ms;
//     property: transform;
//     timing-function: cubic-bezier(0.4, 0, 0.2, 1);
//   }

//   &.translateY {
//     transform: translateY(-100px);
//   }
// }
</style>
